var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M3.85547 17.2501V21.0001H7.60547L18.6655 9.94006L14.9155 6.19006L3.85547 17.2501ZM21.5655 7.04006C21.9555 6.65006 21.9555 6.02006 21.5655 5.63006L19.2255 3.29006C18.8355 2.90006 18.2055 2.90006 17.8155 3.29006L15.9855 5.12006L19.7355 8.87006L21.5655 7.04006Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
